import { ValidateLink } from '../components/ValidateLink';

export const LoginLink = () => <ValidateLink />;
